var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cart-action-buttons"},[_c('a',{staticClass:"btn btn-link",attrs:{"href":"/Store"}},[_vm._v("Continue shopping")]),_c('a',{staticClass:"btn btn-rounded btn-default btn-lg",attrs:{"href":"/Store/Checkout"}},[_vm._v(" Checkout ")])])
}]

export { render, staticRenderFns }